import React, { createRef, Component } from 'react';
import { Button, Fullscreen } from '@bryntum/schedulerpro';
export class BryntumFullscreenButton extends Component {
    constructor() {
        super(...arguments);
        this.elRef = createRef();
    }
    componentDidMount() {
        if (Fullscreen.enabled) {
            this.button = new Button({
                adopt: this.elRef.current,
                icon: 'b-icon b-icon-fullscreen',
                tooltip: 'Fullscreen',
                cls: 'b-raised b-blue',
                toggleable: true,
                onToggle: ({ pressed }) => {
                    pressed ? Fullscreen.request(document.documentElement) : Fullscreen.exit();
                }
            });
            Fullscreen.onFullscreenChange(() => {
                if (this.button) {
                    this.button.pressed = Fullscreen.isFullscreen;
                }
            });
        }
    }
    componentWillUnmount() {
        if (this.button) {
            this.button.destroy();
        }
    }
    render() {
        return (React.createElement("div", { ref: this.elRef }));
    }
}
//# sourceMappingURL=BryntumFullscreenButton.js.map